let options = [
  {
    'id': 'GMT-12:00',
    'offset': -43200,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT-11:00',
    'offset': -39600,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT-10:00',
    'offset': -36000,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT-9:00(Alaska)',
    'offset': -32400,
    'dstSavings': 3600,
    'useDaylight': true
  },
  {
    'id': 'GMT-8:00(Las Vegas, Los Angeles, San Francisco, Vancouver)',
    'offset': -28800,
    'dstSavings': 3600,
    'useDaylight': true
  },
  {
    'id': 'GMT-7:00(Calgary, Denver)',
    'offset': -25200,
    'dstSavings': 3600,
    'useDaylight': true
  },
  {
    'id': 'GMT-6:00(Chicago, Dallas, Huston, Mexico City, New Orleans)',
    'offset': -21600,
    'dstSavings': 3600,
    'useDaylight': true
  },
  {
    'id': 'GMT-5:00(Montreal, Ottawa, Toronto)',
    'offset': -18000,
    'dstSavings': 3600,
    'useDaylight': true
  },
  {
    'id': 'GMT-4:00(Santiago)',
    'offset': -14400,
    'dstSavings': 3600,
    'useDaylight': true
  },
  {
    'id': 'GMT-3:00(Brasilia, Rio de Janeiro, Sao Paulo)',
    'offset': -10800,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT-2:00',
    'offset': -7200,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT-1:00',
    'offset': -3600,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT+0:00(Dublin, London, Lisbon)',
    'offset': 0,
    'dstSavings': 3600,
    'useDaylight': true
  },
  {
    'id': 'GMT+1:00(Amsterdam, Berlin, Brussel, Paris, Prague, Rome, Vienna)',
    'offset': 3600,
    'dstSavings': 3600,
    'useDaylight': true
  },
  {
    'id': 'GMT+2:00(Athens, Beirut, Helsinki)',
    'offset': 7200,
    'dstSavings': 3600,
    'useDaylight': true
  },
  {
    'id': 'GMT+3:00(Moscow, Istanbul)',
    'offset': 10800,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT+4:00(Abu Dhabi, Dubai)',
    'offset': 14400,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT+5:00(Islamabad, Karachi)',
    'offset': 18000,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT+5:30(Bengaluru, Mumbai, New Delhi)',
    'offset': 19800,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT+6:00(Dhaka)',
    'offset': 21600,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT+7:00(Bangkok, Hanoi, Jakarta)',
    'offset': 25200,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT+8:00(Beijing, Hong Kong, Singapore, Taipei)',
    'offset': 28800,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT+9:00(Tokyo, Seoul)',
    'offset': 32400,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT+10:00(Canberra, Melbourne, Sydney)',
    'offset': 36000,
    'dstSavings': 3600,
    'useDaylight': true
  },
  {
    'id': 'GMT+11:00(Solomon Islands)',
    'offset': 39600,
    'dstSavings': 0,
    'useDaylight': false
  },
  {
    'id': 'GMT+12:00(Auckland, Wellington)',
    'offset': 43200,
    'dstSavings': 3600,
    'useDaylight': true
  }
]

export function getTimezoneOptions () {
  return options
}

export default {
  getTimezoneOptions
}



// WEBPACK FOOTER //
// ./src/pages/test/apis/timezoneOption.js